module.exports = __webpack_public_path__ + "img/Programming.588db0b0.png";